import React from 'react';
import SearchBar from '../../SearchBar/SearchBar';
import './JobLoadsManagementHeader.scss';
import { SearchTypeEnum } from '../../../types/SearchTypeEnum';
import JobNavigation from '../../JobProfile/JobNavigation';

interface HeaderProps {
    jobId: string;
    jobName: string;
    isSearchOnLoadId: boolean;
    setIsSearchOnLoadId: React.Dispatch<React.SetStateAction<boolean>>;
}

const JobLoadsManagementHeader = ({
    jobId,
    jobName,
    isSearchOnLoadId,
    setIsSearchOnLoadId,
}: HeaderProps) => {
    return (
        <div className="Header-Container">
            <div className="Header-SearchBar">
                <SearchBar type={SearchTypeEnum.Load}></SearchBar>
            </div>
            <div className="Header-ListHeader">
                <div className="JobLoadManagementHeader-SearchBar">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="JobLoadManagementHeader-Search-Filter">
                                <input
                                    type="radio"
                                    id="loadId"
                                    name="isLoadId"
                                    checked={isSearchOnLoadId}
                                    onChange={() => setIsSearchOnLoadId(true)}
                                />
                                <label htmlFor="loadId" style={{ marginLeft: '5px' }}>
                                    Load Id
                                </label>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="JobLoadManagementHeader-Search-Filter">
                                <input
                                    type="radio"
                                    id="searchAll"
                                    name="isLoadId"
                                    checked={!isSearchOnLoadId}
                                    onChange={() => setIsSearchOnLoadId(false)}
                                />
                                <label htmlFor="searchAll" style={{ marginLeft: '5px' }}>
                                    Search All
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="JobLoadManagementHeader-Search-Container">
                    <div className="Header-JobNameTitle">{jobName}</div>
                </div>
                <div className="Header-RightOptions">
                    <JobNavigation jobId={jobId} active="loads" />
                </div>
            </div>
        </div>
    );
};

export default JobLoadsManagementHeader;
